<style scoped>
.search-area-div {
  width: 100px;
  text-align: center;
}
/deep/.el-col-6 {
  display: flex;
}
.content-main-box {
  height: calc(100vh - 60px - 35px - 66px - 32px);
}
.state-class{
  height: 22px;
  box-sizing: border-box;
  background: #F2FFF5;
  border: 1px solid rgba(220,250,228,1);
  border-radius: 2px;
  font-size: 12px;
  color: #1BA854;
  letter-spacing: 0;
  line-height: 18px;
  padding:4px

  }
.state-class-grey{
  height: 22px;
  box-sizing: border-box;
  background:  #F5F5F5;
  border: 1px solid rgba(217,217,217,1);
  border-radius: 2px;
  font-size: 12px;
  color: #404040;
  letter-spacing: 0;
  line-height: 18px;
  padding:4px
  
  }
</style>
<template>
  <div class="content" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="6">
          <div class="search-area-div"><span style="color: red">*</span>公司名称</div>
          <el-select
            size="mini"
            v-model="page.tenantGuid"
            placeholder="请选择"
            :clearable="true"
            @change="changeTenant"
            filterable
            class="ipt-sty"
          >
            <el-option
              v-for="item in sendTenantList"
              :key="item.sendTenantGuid"
              :label="item.sendTenantName"
              :value="item.sendTenantGuid"
            >
            </el-option>
          </el-select>
        </el-col>

        <el-col :span="6">
          <div class="search-area-div">产品名称</div>
          <el-input
            v-model="page.goodsName"
            size="mini"
            class="ipt-sty"
            placeholder="请输入"
            :clearable="true"
          ></el-input>
        </el-col>

        <el-col :span="6">
          <div class="search-area-div">产品批号</div>
          <el-input
            v-model="page.lotNo"
            size="mini"
            class="ipt-sty"
            placeholder="请输入"
            :clearable="true"
          ></el-input>
        </el-col>

        <el-col :span="6" class="search-btn-box">
          <el-button
            size="mini"
            type="text"
            @click="showMore = !showMore"
            :icon="showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
          >
            {{ showMore ? '收起筛选' : '更多筛选' }}
          </el-button>
          <el-button size="mini" type="info" @click="getData(true)">搜索</el-button>
          <el-button size="mini" type="danger" @click="empty">清空</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="24" v-show="showMore">
        <el-col :span="6">
          <div class="search-area-div">生产日期</div>
          <el-date-picker
            v-model="page.productDate"
            align="right"
            type="date"
            class="ipt-sty"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
            :picker-options="pickerOptions">
          </el-date-picker>
        </el-col>

        <el-col :span="6">
          <div class="search-area-div">有效期</div>
          <el-date-picker
            v-model="page.expiryDate"
            align="right"
            type="date"
            value-format="yyyy-MM-dd"
            class="ipt-sty"
            placeholder="选择日期">
          </el-date-picker>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">启用状态</div>
          <el-select
            size="mini"
            v-model="page.bizState"
            placeholder="请选择"
            :clearable="true"
            filterable
            class="ipt-sty"
          >
            <el-option
              v-for="item in optionList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
      </el-row>
    </div>
    <div class="button-area">
      <el-button  size="mini" type="info" @click="addProduct">
        添加批号
      </el-button>
      <!-- <el-button size="mini" type="danger" @click="getDeleteData(1, '')">批量删除</el-button> -->
      
      <el-button  size="mini" type="info" @click="batchImport()">
        批量导入批号
      </el-button >
      <el-button  size="mini"  @click="exportProduct()">
        导出产品批号
      </el-button>
    </div>
    <div class="back-color-fff content-main-box" :style="'height:' + contentMainHeight + 'px'">
      <el-table
        :data="productInformationList"
        :height="tableHeight"
        ref="tableRef"
        style="width: 100%"
        stripe
        border
        row-key="guid"
        tooltip-effect="light"
      >
        <el-table-column label="序号" width="60" header-align="center" align="center" fixed="left">
          <template slot-scope="scope">
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="tenantName"
          label="企业名称"
          min-width="180"
          header-align="center"
          align="left"
          show-overflow-tooltip
          fixed="left"
        ></el-table-column> -->
        <el-table-column
          prop="tenantName"
          label="企业名称"
          min-width="180"
          header-align="center"
          align="left"
          show-overflow-tooltip
          fixed="left"
        ></el-table-column>
        <el-table-column
          prop="goodsName"
          label="产品名称"
          min-width="180"
          header-align="center"
          align="left"
          fixed="left"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="goodsSpec"
          label="产品规格"
          header-align="center"
          align="left"
          min-width="180"
          show-overflow-tooltip
        ></el-table-column>
        
        <el-table-column
          prop="producer"
          label="生产厂家"
          min-width="160"
          header-align="center"
          align="left"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="lotNo"
          label="产品批号"
          min-width="100"
          header-align="center"
          align="left"
          show-overflow-tooltip
        >
        </el-table-column>
        
      
        
        <el-table-column prop="createTime" label="生产日期" min-width="100" sortable header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.productDate | getDate }}</template>
        </el-table-column>
        
        <el-table-column prop="updateTime" label="有效期" min-width="100" sortable header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.expiryDate | getDate }}</template>
        </el-table-column>

        <el-table-column prop="updateTime" label="启用状态" min-width="70" header-align="center" align="center">
          <template slot-scope="scope">
            <span v-show="scope.row.bizState=='Y'" class="state-class">启用</span>
            <span v-show="scope.row.bizState=='S'" class="state-class-grey">停用</span>
            
          </template>
        </el-table-column>
        
        <el-table-column label="操作" header-align="center" align="center" width="90" fixed="right">
          <template slot-scope="scope">
            <a  class="txt-color" @click="editProduct(scope.row,scope.$index)">编辑 |</a>
            <!-- <a v-if="getBtnPermissionsByName('区域指导价')" class="txt-color" @click="toLink(scope.row.guid)"
              >区域指导价
            </a> -->
            <!-- <a
              class="txt-color"
              v-if="scope.row.isPrescription == 'Y' && getBtnPermissionsByName('医院指导价')"
              @click="toLinkHospital(scope.row.guid)"
              >医院指导价
            </a> -->
            <a  class="txt-color-red" @click="getDelete(scope.row.guid)"> 删除</a>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        class="pt pb back-color-fff"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 50, 100]"
        :current-page="page.pageIndex"
        :page-size="page.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.totalRows"
      >
      </el-pagination>
    </div>
    
  </div>
</template>

<script>
// import btnPermisson from '@/views/mixins/btnPermisson';
import { route } from '@/api/apiRoute';
import store from '@/store';
export default {
  name:'productInformation',
  // mixins: [btnPermisson],
  data() {
    let userinfo = JSON.parse(localStorage.userInfo);
    return {
      userinfo:userinfo,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      showMore: false,
      tableHeight: window.innerHeight - 263,
      contentMainHeight: window.innerHeight - 195,
      productInformationList: [],
      sendTenantList:[],
      page: {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: '',
        goodsName: '',
        lotNo: '',//产品批号
        productDate : '',//生产日期
        expiryDate : '',//有效期
        bizState:null,
      },
      optionList:[
        {
          label:'启用',
          value:'Y'
        },
        {
          label:'停用',
          value:'S'
        },
      ],
      right: '',
      loading: false,
      pictContentList: [],
      url: `/${serverConfig.msCommonAdminCloudService}/obs/upload-file`,
      urlImg: `/${serverConfig.msCommonAdminCloudService}/obs/upload-image`,
      //导入
      active: 0,
      id: '',
      fullscreenLoading: false,
      file: '',
      msg: '',
      showBtn: false,
      progressGuid: '',
      percentage: 0,
      dialogType: '',
    };
  },
  watch: {
    showMore(val, oldVal) {
      if (val) {
        this.tableHeight = window.innerHeight - 296;
        this.contentMainHeight = window.innerHeight - 230;
        return;
      }
      if (!val) {
        this.tableHeight = window.innerHeight - 263;
        this.contentMainHeight = window.innerHeight - 195;
        return;
      }
    }
  },
  // beforeRouteEnter(to, from, next) {
  //   if (from.path === '/addProduct') {
  //     next((vm) => {
  //       vm.getData(false,() => {
  //         if (vm.$store.getters.getPageY) vm.tableScrollToRow(vm.$refs.tableRef, vm.$store.getters.getPageY); // 表格行跳转
  //       });
  //     });
  //   } else {
  //     next();
  //   }
  // },
  activated() {
    if (this.page.tenantGuid) {
      this.getData(false);
    }
  },
  created() {
    // 列表
    // this.getData(false);
    // 获取商品大类数据
    // this.getMenuList();
    this.getTenantOperationRelList();
  },
  methods: {
    //获取公司下拉
    getTenantOperationRelList() {
      let self = this;
      self.api
        .get(
          `/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list?isService=true` +
            '&tenantGuid=' +
            localStorage.guid,
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.sendTenantList = res.data.data || [];
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    // 新产品导入
    batchImport(guid) {
      this.$router.push({ 
        path: '/importProductBatchList', 
        query: { 
          productGuid: this.$route.query.productGuid,
          tenantGuid : this.page.tenantGuid
         
        } 
      });
    },
    
    changeTenant(tenantGuid) {
      this.$forceUpdate();
    },
    
    empty() {
      let self = this;
      self.page = {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: self.page.tenantGuid,
        goodsCode: '',
        goodsName: '',
        lotNo: '',//产品批号
        productDate : '',//生产日期
        expiryDate : '',//有效期
        bizState:null
      };
      self.getData(true);
    },
    getData(flg,callBack) {
      let self = this;
      if(!this.page.tenantGuid) {
        this.$message.warning('请选择所属公司')
        return;
      } 
      self.loading = true;
      if (flg) {
        self.page.pageIndex = 1;
      }
      let page=self.page
    
      page.bizState=self.page.bizState||null,
      
      self.api.postJson(`/${serverConfig.msProductService}/goods-lot/list`,page ).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.loading = false;
          let productInformationList = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
          self.productInformationList = productInformationList;
          self.$nextTick(()=>{
            if (callBack) callBack()
          })
        } else {
          self.$message.error(res.msg || '服务异常');
          console.log(res);
          self.loading = false;
        }
      });
    },
    
    
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val
      this.getData();
    },
    addProduct() {
      this.$router.push(`/addProductBatch?productGuid=${this.$route.query.productGuid}`);
    },
    editProduct(row,index) {
      // this.$store.commit('setPageY', index);
      this.$router.push(`/addProductBatch?guid=${row.guid}&productGuid=${this.$route.query.productGuid}&tenantGuid=${row.tenantGuid}`);
    },
    getDelete(guid) {
      let self = this;
      self.multipleSelection = [];
      self.multipleSelection.push(guid);
      self
        .$confirm('此操作将永久删除, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          self.api
            .postJson(`/${serverConfig.msProductService}/goods-lot/del`, self.multipleSelection)
            .then((res) => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.multipleSelection = [];
                self.$message.success('删除产品成功');
                self.getData(true);
              } else {
                self.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    
    
    //导出产品
    exportProduct() {
      // if (!this.page.tenantGuid) {
      //   this.$message.error('请选择公司')
      //   return
      // }
      let self = this;
      self.fullscreenLoading = true;
      // self.page.performanceGuid = self.$router.history.current.query.guid;
      let query = {
        // guid:'0003',
        pageIndex: 1,
        pageSize: -1,
        tenantGuid: self.page.tenantGuid,
        goodsName: self.goodsName,
        lotNo: self.page.lotNo,
        productDate: self.page.productDate,
        expiryDate: self.page.expiryDate,
        bizState: self.page.bizState,
      };
      self.api.postJsonD(`/${serverConfig.msProductService}/goods-lot/export-info`, query).then(res => {
            let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            console.log('blob',blob);
            let str='产品批号_'
            let fileName = str + this.$moment(new Date()).format('YYYYMMDD');
            let objectUrl = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.download = fileName;
            link.href = objectUrl;
            link.click();
            self.fullscreenLoading = false;
          });
    },
    // 导入产品结束

    /**
     * 获取商品大类字典
     */
    getPositionList() {
      this.api
        .get(`/${serverConfig.msConfigureService}/dict/data/get-by-dictType?dictType=商品大类字典`)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.goodsTreeData = res.data.data || [];
          } else {
            this.$message.error(res.data.data.msg);
          }
        });
    },
    /**
     *  el-table滚动到表格某一行
     *  @param {object} tableElement  表格元素(this.$refs['表格ref值'])
     *  @param {Number} rowIndex   滚动到第几行(从0开始)
     */
    tableScrollToRow(tableElement, rowIndex) {
      const theTableRows = tableElement.bodyWrapper.querySelectorAll('.el-table__body tbody .el-table__row');
      let scrollTop = 0;
      for (let i = 0; i < theTableRows.length; i++) {
        if (i === rowIndex) {
          break;
        }
        scrollTop += theTableRows[i].offsetHeight;
      }
      tableElement.bodyWrapper.scrollTop = scrollTop;
    },
  },
};
</script>
